import { render, staticRenderFns } from "./SummaryNavigation.html?vue&type=template&id=a8487264&scoped=true&lang=html&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"
import style0 from "./SummaryNavigation.scss?vue&type=style&index=0&id=a8487264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8487264",
  null
  
)

export default component.exports